/**
 * @file 面包屑测试
 * @author wangzhuang
 */

import Breadcrumb from './Breadcrumb';
import BreadcrumbItem from './BreadcrumbItem';

import './index.less';

Breadcrumb.Item = BreadcrumbItem;

export default Breadcrumb;